// Renders long selectize lists in chunks while the query is empty — see docs/pdp-roadmap/04-form-performance.md (1.0, 1.5).
(function () {
  var CHUNK = 150;
  var EDGE_PX = 600;

  window.cruiseSelectizeChunked = function (sel) {
    var list = null;
    var rendered = 0;
    var optionsVersion = 0;
    var lastKey = null;
    var openCount = 0;
    var renderedInOpen = -1;

    ['addOption', 'updateOption', 'removeOption', 'clearOptions', 'addOptionGroup', 'removeOptionGroup', 'clearOptionGroups'].forEach(function (name) {
      var orig = sel[name];
      sel[name] = function () {
        optionsVersion++;
        return orig.apply(this, arguments);
      };
    });

    sel.on('dropdown_open', function () {
      openCount++;
    });

    var render = sel.refreshOptions;
    sel.refreshOptions = function () {
      var query = $.trim(this.$control_input.val());
      var key = query + '\u0000' + this.items.join('\u0000') + '\u0000' + optionsVersion;

      // Selectize calls this twice per tap with identical input; the second pass would rebuild the same DOM.
      if (this.isOpen && key === lastKey && renderedInOpen === openCount) return;

      var result = renderChunked.apply(this, arguments);
      lastKey = key;
      renderedInOpen = this.isOpen ? openCount : -1;
      return result;
    };

    function renderChunked() {
      var query = $.trim(this.$control_input.val());
      list = null;
      if (query !== '') return render.apply(this, arguments);

      var items = this.search(query).items;
      var first = CHUNK;
      if (this.items.length) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === this.items[0]) {
            first = i + CHUNK;
            break;
          }
        }
      }

      var maxOptions = this.settings.maxOptions;
      if (items.length <= first || maxOptions <= first) return render.apply(this, arguments);

      this.settings.maxOptions = first;
      try {
        var result = render.apply(this, arguments);
      } finally {
        this.settings.maxOptions = maxOptions;
      }
      list = items.slice(0, maxOptions);
      rendered = first;
      return result;
    }

    function appendChunk() {
      var content = sel.$dropdown_content[0];
      var to = Math.min(rendered + CHUNK, list.length);
      var groupEl = content.lastElementChild;
      var groupVal = groupEl && groupEl.getAttribute('data-group');
      var frag = document.createDocumentFragment();

      for (var i = rendered; i < to; i++) {
        var opt = sel.options[list[i].id];
        if (!opt) continue;
        var g = opt[sel.settings.optgroupField] || '';

        if (g !== groupVal) {
          if (sel.optgroups.hasOwnProperty(g)) {
            groupEl = document.createElement('div');
            groupEl.className = 'optgroup';
            groupEl.setAttribute('data-group', g);
            groupEl.appendChild(sel.render('optgroup_header', sel.optgroups[g]));
            frag.appendChild(groupEl);
          } else {
            groupEl = null;
          }
          groupVal = g;
        }

        // Clone: render() returns a cached node, and classes added in the page would leak into later renders.
        var el = sel.render('option', opt).cloneNode(true);
        if (sel.items.indexOf(opt[sel.settings.valueField]) !== -1) el.classList.add('selected');
        (groupEl || frag).appendChild(el);
      }

      content.appendChild(frag);
      rendered = to;
    }

    function onScroll(e) {
      if (!list || rendered >= list.length) return;
      var el = e.currentTarget;
      if (el.scrollHeight - el.scrollTop - el.clientHeight > EDGE_PX) return;
      appendChunk();
    }

    // Keyboard navigation stops at the last rendered option, so append before the active one gets there.
    var setActive = sel.setActiveOption;
    sel.setActiveOption = function ($option) {
      var result = setActive.apply(this, arguments);
      var el = $option && $option[0];
      var last = sel.$dropdown_content[0].lastElementChild;
      if (list && rendered < list.length && el && last &&
          last.getBoundingClientRect().bottom - el.getBoundingClientRect().bottom < EDGE_PX) {
        appendChunk();
      }
      return result;
    };

    // Which of the two actually scrolls depends on theme CSS, so listen on both.
    sel.$dropdown[0].addEventListener('scroll', onScroll, { passive: true });
    sel.$dropdown_content[0].addEventListener('scroll', onScroll, { passive: true });
  };
})();
